import React from 'react';
import uuidv4 from 'uuid';
import update from 'immutability-helper';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { Tooltip, Fade } from '@material-ui/core';
import { Typography } from '@material-ui/core';

import { setSaveState } from '../../../actions';

//comopnents:
import NeuriteGrid from '../../../components/neurite_grid';
import { LocalConvenienceStoreOutlined } from '@material-ui/icons';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 550,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 50,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    width_where: {
        width: 500,
    },
    width_descr: {
        width: 500,
    },
    width_int_md: {
        width: 100,
    },
    width_date: {
        width: 100,
    },
    grid: {
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 550,
    }

});

class EditSegmentacion extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.segmentacion.id ? this.props.segmentacion.id : uuidv4(),
            centroId: this.props.centroId ? this.props.centroId : undefined,
            usuarioId: this.props.usuarioId ? this.props.usuarioId : undefined,
            descr: this.props.segmentacion.descr ? this.props.segmentacion.descr : '',
            where_clause: this.props.segmentacion.where_clause ? this.props.segmentacion.where_clause : '',
            contador: this.props.segmentacion.contador
                ? this.props.segmentacion.contador
                : undefined,
            fecha: this.props.segmentacion.fecha
                ? this.props.segmentacion.fecha.slice(0, 10)
                : new Date().toISOString().slice(0, 10),
            segmentacionLineaList: this.props.segmentacion.dcSegmentacionLinea ? this.props.segmentacion.dcSegmentacionLinea : [],
        };
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {
        this.setState({ ...this.state, [field]: event });
    };

    handleDeleteRow = (linea) => {
        let rows = this.state.segmentacionLineaList.filter(f => f.id !== linea.id);
        // this.props.setSaveState(true);
        this.setState({ ...this.state, segmentacionLineaList: rows });
    };

    handleRowsUpdated = ({ fromRow, toRow, updated }) => {

        if (fromRow !== toRow) return; //we only allow modficiation of a single row

        let updatedRow = update(this.state.segmentacionLineaList[fromRow], { $merge: updated });

        // if (this.props.checkValues(updatedRow)) {
        this.modifyRow(updatedRow);
        // }

    };

    modifyRow = (linea) => {
        var rows = this.state.segmentacionLineaList.map((row) => {
            if (row.id === linea.id) {
                return {
                    ...row,
                    iField: parseInt(linea.iField),
                    iOperator: parseInt(linea.iOperator),
                    param1: linea.param1,
                    param2: linea.param2,
                };
            }
            else return row;
        });
        // this.props.setSaveState(true);
        this.setState({ ...this.state, segmentacionLineaList: rows });
    };

    handleNewRow = () => {
        let minId = -1;
        const rows = this.state.segmentacionLineaList.map((row) => {
            if (row.id !== undefined && row.id <= minId) minId = row.id - 1;
            return row
        });

        if (rows === undefined) rows = [];
        rows.push({ id: minId });

        // this.props.setSaveState(true);
        this.setState({ ...this.state, segmentacionLineaList: rows });
    };

    calcular = () => {

        // this.props.setSaveState(true);
        this.setState({ ...this.state, contador: 567 });
    };


    render() {
        const { classes } = this.props;

        const optionsField = [];
        optionsField.push({ id: 1, value: 1, text: 'Saldo tarjeta' });
        optionsField.push({ id: 2, value: 2, text: 'Dias sin uso' });
        optionsField.push({ id: 3, value: 3, text: 'Núm. Tarjeta (concreta)' });
        optionsField.push({ id: 99, value: 99, text: 'Where genérico' });

        const optionsOperator = [];
        optionsOperator.push({ id: 1, value: 1, text: 'igual a...' });
        optionsOperator.push({ id: 2, value: 2, text: 'mayor que...' });
        optionsOperator.push({ id: 3, value: 3, text: 'menor que...' });
        optionsOperator.push({ id: 4, value: 4, text: 'entre ...y...' });

        return (
            <div className={classes.root}>
                <div className={classes.containerPair}>
                    <FormControl className={`${classes.formControl} ${classes.width_descr}`}>
                        <TextField
                            id={'descr'}
                            label={'Descripción'}
                            placeholder={'Descripción'}
                            margin="normal"
                            autoFocus
                            value={this.state.descr}
                            onChange={event =>
                                this.handleValueChange(event, 'descr')
                            }
                        />
                    </FormControl>
                </div>

                <div className={classes.grid}>
                    <NeuriteGrid
                        id="m_r_p"
                        columns={[
                            { key: 'iField', name: 'Campo', tooltip: 'Campo del filtro', type: 'dropdown', editable: true, dragable: false, width: 130 },
                            { key: 'iOperator', name: 'Operador', type: 'dropdown', editable: true, dragable: false, width: 120 },
                            { key: 'param1', name: 'Param. 1', editable: true, dragable: false, width: 150 },
                            { key: 'param2', name: 'Param. 2', editable: true, dragable: false, width: 70 },
                        ]}
                        rows={this.state.segmentacionLineaList}
                        height={250}
                        buttonEdit={false}
                        buttonDelete={true}
                        buttonNew={true}
                        dropdownOptions={{
                            iField: optionsField,
                            iOperator: optionsOperator,
                        }}

                        onNewRowClick={this.handleNewRow}
                        onRowsUpdated={this.handleRowsUpdated}
                        onDeleteClick={this.handleDeleteRow}
                    />
                </div>
                <div className={classes.containerPair}>
                    <FormControl className={`${classes.formControl} ${classes.width_where}`}>
                        <Tooltip title="Condición Where para la selección de los clientes" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id={'where_clause'}
                                label={'Where Clause'}
                                placeholder={'Where Clause'}
                                margin="normal"
                                autoFocus
                                value={this.state.where_clause}
                                disabled={true}
                            />
                        </Tooltip>
                    </FormControl>
                </div>
                <div className={classes.containerPair}>
                    <FormControl className={`${classes.formControl} ${classes.width_date}`}>
                        <Tooltip title="Fecha en que se calculó el contador" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id={'fecha'}
                                label={'Fecha'}
                                placeholder={'Fecha'}
                                margin="normal"
                                autoFocus
                                value={this.state.fecha}
                                disabled={true}
                            />
                        </Tooltip>
                    </FormControl>
                    <FormControl className={`${classes.formControl} ${classes.width_int_md}`}>
                        <Tooltip title="Número de clientes en la selección" TransitionComponent={Fade} TransitionProps={{ timeout: 600 }} classes={{ tooltip: this.props.classes.tooltip }}>
                            <TextField
                                id={'contador'}
                                label={'Contador'}
                                placeholder={'Contador'}
                                className={classes.textField}
                                margin="normal"
                                value={this.state.contador}
                                disabled={true}
                            />
                        </Tooltip>
                    </FormControl>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.calcular()}
                    >
                        Calcular
                    </Button>
                </div>
                <div className={classes.buttonsContainer}>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="secondary"
                        onClick={() => this.props.hideDialog()}
                    >
                        Cerrar
                    </Button>
                    <Button
                        className={classes.buttonsBottom}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            const segmentacion = {
                                id: this.state.id,
                                centroId: this.state.centroId,
                                usuarioId: this.state.usuarioId,
                                descr: this.state.descr,
                                where_clause: this.state.where_clause,
                                fecha: this.state.fecha,
                                contador: this.state.contador,
                                segmentacionLineaList: this.state.segmentacionLineaList,
                            };
                            console.log("EO4");
                            console.log(segmentacion);
                            if (this.props.checkSegmentacion(segmentacion)) {
                                //     this.props.okHandler(segmentacion);
                                //     this.props.hideDialog();
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </div>
        );
    }
}

EditSegmentacion.propTypes = {
    segmentacion: PropTypes.object.isRequired,
    checkSegmentacion: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditSegmentacion);
